<template>
  <div>
    <andes-header></andes-header>
    <breadcrumb activePage="1"></breadcrumb>
    <div class="container passengersPage">
      <div class="row">
        <div class="col-md-9">
          <h3>{{ $t('DATOS DE LOS PASAJEROS') }}</h3>
          <p>{{ $t('Por favor ingrese los datos de todos los pasajeros, como figuran en su documento de identificación.') }}</p>
          <hr/>

          <div v-for="(adult, index) in adults" :key="`adult-${index}`" class="mb-5">
            <h4><font-awesome-icon icon="user"/> {{ $t('PASAJERO') }} {{index + 1}} - {{ $t('Adulto') }}</h4>
            <passenger-form :passenger="adult" ref="adult" type="adult"></passenger-form>
          </div>
          <div v-for="(child, index) in childs" :key="`child-${index}`" class="mb-5">
            <h4><font-awesome-icon icon="user"/> {{ $t('PASAJERO') }} {{index + adultCount + 1}} - {{ $t('Menor') }}</h4>
            <passenger-form :passenger="child" ref="child" type="child"></passenger-form>
          </div>
          <div v-for="(inf, index) in infants" :key="`inf-${index}`" class="mb-5">
            <h4><font-awesome-icon icon="user"/> {{ $t('INFANTE') }} {{index + 1}}</h4>
            <passenger-form :passenger="inf" ref="inf" type="infant"></passenger-form>
          </div>
          <hr class="mb-3"/>
          <h4><font-awesome-icon icon="envelope"/> {{ $t('INFORMACION DE CONTACTO') }}</h4>
          <contact-form :contact="contact" ref="contactView" class="mb-5" :onCopyFirstAdult="onCopyFirstAdult"></contact-form>
        </div>
        <div class="col-md-3">
          <summary-form :onContinue="onContinue"></summary-form>
        </div>
      </div>
    </div>
    <session-timeout-modal></session-timeout-modal>
    <loading-modal v-if="loading"></loading-modal>
    <andes-footer></andes-footer>
  </div>
</template>

<script>
  import { passengersInfo } from '@/api/api';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import Breadcrumb from '../components/Breadcrumb';
  import SummaryForm from '../components/SummaryForm';
  import PassengerForm from '../components/passengers/PassengerForm';
  import ContactForm from "../components/passengers/ContactForm";
  import AndesHeader from "../components/AndesHeader";
  import AndesFooter from "../components/AndesFooter";
  import SessionTimeoutModal from "../components/SessionTimeout";
  import LoadingModal from "../components/LoadingModal";

  export default {
    name: 'passengers',
    components: {
      LoadingModal,
      SessionTimeoutModal,
      AndesHeader,
      ContactForm,
      Breadcrumb,
      SummaryForm,
      AndesFooter,
      PassengerForm},
    data: function () {
      return {
        adults: [],
        childs: [],
        infants: [],
        contact: {"EmailAddress":"", "FirstName":"", "LastName": "", "HomePhone":"", "OtherPhone":""}
      }
    },
    computed: {
      ...mapState(['booking', 'adultCount', 'childCount', 'infantCount', 'loading']),
      childCountInt: function() {
        return parseInt(this.childCount);
      },
      adultCountInt: function() {
        return parseInt(this.adultCount)
      },
      infantCountInt: function() {
        return parseInt(this.infantCount)
      },
    },
    methods: {
      onContinue: function() {
        var isValid = true;
        for (var i=0; i < this.adultCount; i++) {
          isValid = this.$refs["adult"][i].validate() && isValid;
        }

        for (i=0; i < this.childCount; i++) {
          isValid = this.$refs["child"][i].validate() && isValid;
        }

        for (i=0; i < this.infantCount; i++) {
          isValid = this.$refs["inf"][i].validate() && isValid;
        }

        isValid = this.$refs.contactView.validate() && isValid;
        if (isValid) {
          this.postInformation();

          /*gtag('event', 'updated', {
            'event_category':"passengers"
          });*/
        }
      },
      postInformation: function () {
        this.$store.commit('loading', true);
        passengersInfo(this.booking.BookingID, [...this.adults, ...this.childs, ...this.infants], this.contact, true, (result) => {
          this.$store.dispatch('updateBooking', result);
          this.$router.push('extras');
          this.$store.commit('loading', false);
        });
      },
      onCopyFirstAdult: function () {
        this.contact.FirstName = this.adults[0].FirstName;
        this.contact.LastName = this.adults[0].LastName;
      }
    },
    mounted() {
      if (_.isEmpty(this.booking)){
       this.$router.replace('/');
      }
      const nodeEnv = (process.env && process.env.NODE_ENV) ? process.env.NODE_ENV : '';
      const isDev = nodeEnv === 'development' || nodeEnv === '"development"';
      if (this.booking) {
        const departureDate = this.booking?.Passengers?.[0]?.Segments?.[0]?.DepartureDate;
        const baseDeparture = departureDate ? moment(departureDate, "YYYY-MM-DD") : moment();

        const dummyAdultDOB = baseDeparture.clone().subtract(30, 'years').format("YYYY-MM-DD");
        const dummyChildDOB = baseDeparture.clone().subtract(6, 'years').format("YYYY-MM-DD");
        const dummyInfantDOB = baseDeparture.clone().subtract(1, 'years').format("YYYY-MM-DD");
        const dummyGender = "MALE";
        const dummyNationality = "AR";
        const dummyDocType = "DNI";
        const dummyAdultDocNumber = "12345678";
        const dummyChildDocNumber = "87654321";
        const dummyInfantDocNumber = "11223344";
        const dummyLastName = "PEREZ";
        const dummyFirstName = "JUAN";
        const dummyMiddleName = "DEV";
        const dummyEmail = "dev@example.com";
        const dummyHomePhone = "11111111";
        const dummyOtherPhone = "22222222";

        this.adults = []
        this.childs = []
        this.infants = []

        for (var passenger of this.booking.Passengers) {
          const isAdultType = passenger.PaxType == 'ADT' || passenger.PaxType == 'NREV' || passenger.PaxType == 'CBUS';
          const paxDOB = isAdultType ? dummyAdultDOB : dummyChildDOB;
          const paxDocNumber = isAdultType ? dummyAdultDocNumber : dummyChildDocNumber;

          var p = {
            FirstName: isDev ? dummyFirstName : passenger.FirstName,
            MiddleName: isDev ? dummyMiddleName : passenger.MiddleName,
            LastName: isDev ? dummyLastName : passenger.LastName,
            DOB: isDev ? paxDOB : passenger.DOB,
            Gender: isDev ? dummyGender : passenger.Gender,
            PaxType: passenger.PaxType,
            DocTypeCode: isDev ? dummyDocType : passenger.DocTypeCode,
            DocNumber: isDev ? paxDocNumber : passenger.DocNumber,
            Nationality: isDev ? dummyNationality : passenger.Nationality,
            PassportDueDate:"",
            PassportCountry:""
          }
          if (passenger.PaxType == 'ADT' || passenger.PaxType == 'NREV' || passenger.PaxType == 'CBUS') {
            this.adults.push(p);
          } else {
            this.childs.push(p);
          }

          for (var infant of passenger.Infants) {
            this.infants.push({
              FirstName: isDev ? dummyFirstName : infant.FirstName,
              MiddleName: isDev ? dummyMiddleName : infant.MiddleName,
              LastName: isDev ? dummyLastName : infant.LastName,
              DOB: isDev ? dummyInfantDOB : infant.DOB,
              Gender: isDev ? dummyGender : infant.Gender,
              PaxType: "INF",
              DocTypeCode: isDev ? dummyDocType : infant.DocTypeCode,
              DocNumber: isDev ? dummyInfantDocNumber : infant.DocNumber,
              Nationality: isDev ? dummyNationality : infant.Nationality,
              PassportDueDate:"",
              PassportCountry:""
            })
          }
        }

        if (isDev) {
          // Para no dejar la pantalla vacia en desarrollo.
          this.contact = {
            "EmailAddress": dummyEmail,
            "FirstName": dummyFirstName,
            "LastName": dummyLastName,
            "HomePhone": dummyHomePhone,
            "OtherPhone": dummyOtherPhone
          }
        } else if (this.booking.ContactInformation && this.booking.ContactInformation.length > 0) {
          this.contact = {
            "EmailAddress": this.booking.ContactInformation[0].EmailAddress,
            "FirstName":this.booking.ContactInformation[0].FirstName,
            "LastName": this.booking.ContactInformation[0].LastName,
            "HomePhone": this.booking.ContactInformation[0].HomePhone,
            "OtherPhone":""
          }
        }
      }
    }

  }
</script>

